/** Invoicing group (canonical `M8XIPbVz`) — Invoices (Brief 05). Invoices bill
 *  fees and raise LIVE Xero invoices; create is irreversible. The UI only
 *  creates + lists — it NEVER PATCHes an invoice (PATCH /invoices/{id} is the
 *  Make/Xero inbound sync path; invoice state arrives by re-fetching the list).
 *  Self-contained against GET /invoices?job_id; not in /detail. */

import { api } from "./client";
import type {
  InvoicesListResponse,
  InvoiceCreateInput,
  InvoiceCreateResponse,
  InvoiceDashboardResponse,
} from "@/types";

/** GET /invoices?job_id — a job's invoices (lines embedded) + summary. */
export function listInvoices(jobId: number): Promise<InvoicesListResponse> {
  return api.get<InvoicesListResponse>("inv", "invoices", { query: { job_id: jobId } });
}

/** GET /dashboard — cross-job KPIs + enriched invoice rows in one call
 *  (as_of_date defaults to today server-side, so it's omitted). Read-only. */
export function getInvoiceDashboard(): Promise<InvoiceDashboardResponse> {
  return api.get<InvoiceDashboardResponse>("inv", "dashboard");
}

/** POST /invoices/create — bill fee lines → raises an AUTHORISED Xero invoice,
 *  persists it + lines, and bumps each fee's amount_invoiced/status. Irreversible
 *  external side effect: confirm + guard against double-submit. Xero is integral
 *  — a Xero failure fails the whole create with nothing persisted. */
export function createInvoice(input: InvoiceCreateInput): Promise<InvoiceCreateResponse> {
  return api.post<InvoiceCreateResponse>("inv", "invoices/create", { body: input });
}
